export enum ComponentType {
  Engine = 0,
  APU = 1,
  Airframe = 2,
  Custom
}
